export const Header = () => {
  return (
    <header
      data-testid="site-header"
      className="pointer-events-none fixed inset-x-0 top-0 z-50 flex h-16 items-center justify-between px-5 md:h-[72px] md:px-10"
    >
      <a
        href="/"
        data-testid="header-wordmark"
        className="pointer-events-auto relative z-10 font-display text-sm font-semibold tracking-[0.35em] text-white"
      >
        SERVIN&nbsp;LABS
      </a>
      <a
        href="mailto:angelobusinessai@gmail.com"
        data-testid="header-contact-link"
        className="pointer-events-auto relative z-10 hidden text-xs tracking-[0.2em] text-white/40 transition-colors duration-300 hover:text-white md:block"
      >
        CONTACTO
      </a>
      <span className="relative z-10 block h-1.5 w-1.5 rounded-full bg-white/60 md:hidden" aria-hidden="true" />
    </header>
  );
};
